<template>
    <c-logo-mobile-header-top
        :href="route_home"
        class="logo-mobile-top"
    >
        <img 
            :src="logoUrl"
            :alt="fantasyName"
            loading="lazy"
            width="100"
            height="50"
        />
    </c-logo-mobile-header-top>
</template>

<script>
import { CLogoMobileHeaderTop } from '../Styles/Header/styled'

export default {
    name: 'LogoMobileHeaderTop',
    props: {
        route_home: {
            required: true
        },
        active_header_above_banner: {
            default: false
        },
    },
    components: {
        'c-logo-mobile-header-top': CLogoMobileHeaderTop
    },
    data() {
        return {
            company: this.$root.$children[0].$attrs.company
        }
    },
    computed: {
        logoUrl() {
            let logo = this.company?.logo_url ?? ""
            return (
                this.route_home + '/' == window.location.href && JSON.parse(this.active_header_above_banner) ?
                (this.company?.secondary_logo_url ?? logo) : logo
            )
        },
        fantasyName() {
            return this.company?.nome_fantasia ?? ''
        }
    }
}
</script>